import PropTypes from "prop-types";
import ClientId from "data/ClientId";

export const recordIdType = PropTypes.oneOfType([
    PropTypes.number,
    ClientId.propType,
]);



// WEBPACK FOOTER //
// ./app/data/util/typedefs.js